import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ContactPaymentDetailsPage.InfoPanel', {
    added: 'Added {bankAccountName}',
    edited: 'Edited {bankAccountName}',
    removed: 'Removed {bankAccountName}',
});
